<template>
  <div>
    <surveys-table
      surveyName="NAPSI"
      surveyCode="NAPSI"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_NAPSI,
        viewDetail: permissions.SEE_DETAIL_SURVEY_NAPSI,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
